export default __webpack_public_path__ + "static/ProValue_3@mob-1f7a58fb5b1edea8635cf9880719c4bb.png";